import Request from './Request'

function queryString(params = {}) {
  const query = new URLSearchParams(Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== ''))
  const result = query.toString()
  return result ? `?${result}` : ''
}

export default class ClientReportAccessService {
  /** Toggle state for every report support can turn on/off for a client. */
  static async list({ client_id: clientId, source_client_id: sourceClientId } = {}) {
    // rethrowError so a failed load surfaces as an error instead of an empty list.
    const response = await Request.get(
      `/api/admin/client-reports${queryString({ client_id: clientId, source_client_id: sourceClientId })}`,
      undefined,
      false,
      true,
    )
    return response?.data || { groups: [] }
  }

  /**
   * Turn one report on or off for a client. Enabling copies the report's
   * GLOBAL/DEFAULT filter rows from source_client_id.
   */
  static async toggle({ client_id: clientId, source_client_id: sourceClientId, report_name: reportName, enabled }) {
    const response = await Request.post('/api/admin/client-reports/toggle', {
      client_id: clientId,
      source_client_id: sourceClientId,
      report_name: reportName,
      enabled,
    })
    return response?.data || {}
  }
}
